import { render, staticRenderFns } from "./employee-detail.vue?vue&type=template&id=0a06cbf2&scoped=true"
import script from "./employee-detail.vue?vue&type=script&lang=js"
export * from "./employee-detail.vue?vue&type=script&lang=js"
import style0 from "./employee-detail.vue?vue&type=style&index=0&id=0a06cbf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a06cbf2",
  null
  
)

export default component.exports